import React from "react";
import PageHeader from "@/components/PageHeader";

export default function PrivacyPolicy() {
  const lastUpdated = "1 February 2026";

  return (
    <>
      <PageHeader
        testId="privacy-header"
        eyebrow="Legal"
        title="Privacy Policy"
        intro="How Evergreen Global Holdings Ltd collects, uses and protects personal information in line with UK GDPR and applicable data protection law."
      />

      <section className="evg-section bg-white">
        <div className="evg-container max-w-4xl">
          <span
            className="text-xs uppercase tracking-[0.18em] text-[#0A1F44]/55"
            data-testid="privacy-last-updated"
          >
            Last Updated: {lastUpdated}
          </span>

          <div className="mt-10 space-y-10">
            <Block title="1. Introduction">
              Evergreen Global Holdings Ltd (“Evergreen”, “we”, “our”, “us”) is committed to
              protecting the privacy of visitors, investors, partners and other individuals who
              interact with our website at evergreenglobalholdings.com. This policy explains the
              personal information we collect, how we use it, and the rights you have in relation
              to that information.
            </Block>

            <Block title="2. Information We Collect">
              We may collect information you provide directly to us (such as your name, email,
              organisation and message when submitting a contact or investor enquiry form), and
              technical information collected automatically (such as IP address, browser type and
              cookie identifiers, where consented).
            </Block>

            <Block title="3. How We Use Information">
              Information is used to respond to enquiries, manage investor relations and
              correspondence, improve our website performance, and meet legal and regulatory
              obligations. We do not sell personal information.
            </Block>

            <Block title="4. Cookies">
              Our website uses cookies and similar technologies. Where required by law, we will
              ask for your consent before placing non-essential cookies. You may modify your
              preferences at any time via Cookie Settings in the footer. Full details are in our
              Cookie Policy.
            </Block>

            <Block title="5. Lawful Bases">
              We process personal information on the basis of legitimate interests (for example,
              responding to enquiries), consent (for non-essential cookies), and to meet legal
              obligations.
            </Block>

            <Block title="6. Data Retention">
              Personal information is retained only as long as necessary for the purposes for
              which it was collected, or as required to meet legal, regulatory, accounting or
              reporting obligations.
            </Block>

            <Block title="7. Your Rights">
              Subject to applicable law, you have the right to access, rectify, erase, restrict
              or object to processing of your personal information, and the right to data
              portability. To exercise these rights, please contact
              privacy@evergreenglobalholdings.com.
            </Block>

            <Block title="8. International Transfers">
              Where personal information is transferred outside the UK or EEA, we use appropriate
              safeguards including standard contractual clauses where applicable.
            </Block>

            <Block title="9. Changes to this Policy">
              We may update this policy from time to time. Material changes will be reflected by
              an updated “Last Updated” date and, where appropriate, additional notice on the
              website.
            </Block>

            <Block title="10. Contact">
              For privacy-related queries, contact us at privacy@evergreenglobalholdings.com.
            </Block>
          </div>
        </div>
      </section>
    </>
  );
}

function Block({ title, children }) {
  return (
    <div className="pb-8 border-b border-[#0A1F44]/10 last:border-0">
      <h2 className="font-serif text-2xl md:text-3xl leading-tight">{title}</h2>
      <p className="mt-5 evg-body">{children}</p>
    </div>
  );
}
